import "./KisDefectOverview.scss";
export default {
  name: "KisDefectOverview",
  components: {},
  data: () => ({
    config: {},
    ignoreUser: 0,
    ignoreUserItems: [
      { text: "Meine Aktivitäten", value: 0 },
      { text: "Alle Aktivitäten", value: 1 }
    ]
  }),
  async mounted() {
    try {
      await this.$store.dispatch("getDefectCategories");
      await this.$store.dispatch("getAllUsers");
      await this.loadStatistics();
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  methods: {
    async loadStatistics() {
      await this.$store.dispatch("getDefectStatistics");
    },
    getCategoryTitle(categoryId) {
      return this.defectCategories.find(cat => cat._id === categoryId)?.title;
    },
    goTo(path) {
      this.$router.push(path);
    },
    getUserAvatar(updatedBy) {
      let user = this.users?.find(user => user._id === updatedBy);
      if (!user && this.user?._id === updatedBy) {
        user = this.user;
      }
      return user?.avatar_uri || "";
    }
  },
  computed: {
    statistics() {
      return this.$store.state.defectStatistics;
    },
    lastActivities() {
      return this.$store.state.defectStatistics?.latestDefects ?? [];
    },
    defectChartTitle() {
      return `${this.statistics?.defectStatistics?.all ?? 0} Meldungen`;
    },
    defectCategories() {
      return this.$store.state.defectCategories;
    },
    user() {
      return this.$store.state.currentUser;
    },
    users() {
      return this.$store.state.users ?? [];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isDefectsAdmin() {
      return (
        this.isAdmin ||
        this.currentUser?.scopes?.includes("role:kis_defects_admin")
      );
    },
    isDefectsUser() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:kis_defects")
      );
    }
  }
};
